module.exports = __webpack_public_path__ + "img/img-9.e0847ca1.png";